// Hana — the director: the song is the clock; everything else follows it.
(function () {
  const H = window.HANA;
  const { clamp, lerp, smooth } = H;
  const $ = s => document.querySelector(s);
  const DEV = /dev/.test(location.hash);

  H.applyText();
  const G = H.G;
  G.init($('#gl'));
  H.Lyrics.init($('#lyrics'));

  const audio = new Audio();
  audio.preload = 'auto';
  audio.src = 'music/hana.m4a';

  const S = H.state = {
    mode: 'title',      // title | play | end
    t: 0,               // song time shown
    clock: 0,           // real seconds since load
    playing: false,
    manual: null,       // dev: a fixed song time
    seek: null,         // { form, t0, at } a soft change after a jump
    hold: 1,
    seed: [1.15, 0, 1]
  };

  // ---- audio
  const listen = $('#listen');
  const ready = () => { listen.disabled = false; listen.textContent = H.text('listen'); };
  audio.addEventListener('canplay', ready, { once: true });
  setTimeout(() => { if (listen.disabled) ready(); }, 4000);
  audio.addEventListener('ended', () => { S.playing = false; S.mode = 'end'; S.t = H.duration; $('#again').classList.add('on'); showBar(); });
  audio.addEventListener('play', () => { S.playing = true; setIcon(); });
  audio.addEventListener('pause', () => { S.playing = false; setIcon(); });

  // what you hear lags the media clock by the output's latency (Bluetooth headphones: a fifth of a second or more)
  let latency = 0;
  function measureLatency() {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      const ctx = new AC();
      latency = Math.min(0.5, (ctx.outputLatency || 0) + (ctx.baseLatency || 0));
      setTimeout(() => { latency = Math.min(0.5, (ctx.outputLatency || 0) + (ctx.baseLatency || 0)); ctx.close(); }, 1500);
    } catch (e) {}
  }

  function begin() {
    if (!latency) measureLatency();
    S.mode = 'play';
    $('#title').classList.add('gone');
    $('#again').classList.remove('on');
    audio.currentTime = 0; S.t = 0;
    audio.play().catch(() => {});
    showBar();
  }
  listen.addEventListener('click', () => { if (S.mode === 'title') begin(); });   // once it has faded, it does nothing
  $('#again').addEventListener('click', () => { jump(0); begin(); });

  function toggle() {
    if (S.mode === 'title') return begin();
    if (S.mode === 'end') { jump(0); return begin(); }
    if (audio.paused) audio.play().catch(() => {}); else audio.pause();
  }
  function jump(t) {
    t = clamp(t, 0, H.duration - 0.05);
    const cur = H.sceneAt(S.t);
    S.seek = { form: cur.k < 0.5 ? cur.A : cur.B, t0: S.t, at: S.clock, from: currentPose() };
    S.t = t;
    try { audio.currentTime = t; } catch (e) {}
    if (S.mode === 'end' && t < H.duration - 0.1) { S.mode = 'play'; $('#again').classList.remove('on'); }
  }

  // ---- controls
  const bar = $('#bar');
  let barTimer = 0;
  function showBar() {
    if (S.mode === 'title') return;
    bar.classList.add('on');
    clearTimeout(barTimer);
    barTimer = setTimeout(() => { if (S.playing) bar.classList.remove('on'); }, 2600);
  }
  function setIcon() {
    $('#playIcon').setAttribute('d', S.playing ? 'M5 3v10M11 3v10' : 'M5 3l8 5-8 5z');
    $('#play').setAttribute('aria-label', H.text(S.playing ? 'aria.pause' : 'aria.play'));
  }
  $('#play').addEventListener('click', e => { e.stopPropagation(); toggle(); });
  $('#full').addEventListener('click', e => {
    e.stopPropagation();
    const d = document;
    if (d.fullscreenElement || d.webkitFullscreenElement) (d.exitFullscreen || d.webkitExitFullscreen).call(d);
    else { const el = d.documentElement; (el.requestFullscreen || el.webkitRequestFullscreen || (() => {})).call(el); }
  });
  const seekEl = $('#seek');
  let dragging = false;
  const seekTo = e => { const r = seekEl.getBoundingClientRect(); jump(clamp((e.clientX - r.left) / r.width, 0, 1) * H.duration); };
  seekEl.addEventListener('pointerdown', e => { e.stopPropagation(); dragging = true; seekEl.setPointerCapture(e.pointerId); seekTo(e); });
  seekEl.addEventListener('pointermove', e => { if (dragging) seekTo(e); });
  seekEl.addEventListener('pointerup', () => { dragging = false; });
  seekEl.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft') { jump(S.t - 5); e.preventDefault(); }
    if (e.key === 'ArrowRight') { jump(S.t + 5); e.preventDefault(); }
  });

  addEventListener('keydown', e => {
    if (e.target === seekEl) return;
    if (e.code === 'Space') { e.preventDefault(); toggle(); }
    else if (e.key === 'ArrowLeft' && S.mode !== 'title') jump(S.t - 5);
    else if (e.key === 'ArrowRight' && S.mode !== 'title') jump(S.t + 5);
    else if (e.key === 'f' || e.key === 'F') $('#full').click();
    showBar();
  });

  // the pointer only wakes the controls; the light is never pushed around
  addEventListener('pointermove', showBar);
  addEventListener('pointerdown', showBar);

  // ---- the frame
  function poseAt(t) {
    const sc = H.sceneAt(t);
    const k = H.ease(sc.k);
    const cam = H.mixCam(H.camAt(sc.A, t), H.camAt(sc.B, t), k);
    const sky = H.mixSky(H.skyAt(sc.A, t), H.skyAt(sc.B, t), k);
    return { sc, cam, sky };
  }
  function currentPose() { return S.pose ? { cam: S.pose.cam, sky: S.pose.sky } : null; }

  const feat = {};
  let last = performance.now(), raf = 0;
  function frame(now) {
    raf = requestAnimationFrame(frame);
    const dt = Math.min(0.1, (now - last) / 1000);
    last = now;
    S.clock += dt;
    step(dt);
  }

  function step(dt) {
    // the song is the clock; between its updates we glide
    if (S.manual != null) S.t = S.manual;
    else if (S.mode === 'play' && S.playing) {
      const at = Math.max(0, audio.currentTime - latency);
      S.t += dt;
      if (Math.abs(at - S.t) > 0.12) S.t = at; else S.t += (at - S.t) * 0.08;
    }
    const t = S.t;

    let pose = poseAt(t);
    let A = pose.sc.A, B = pose.sc.B, k = pose.sc.k, tA = t, tB = t;
    // after a jump, the light flows from where it was into the new place
    if (S.seek) {
      const u = (S.clock - S.seek.at) / 1.5;
      if (u >= 1) S.seek = null;
      else {
        const e = H.ease(u);
        A = S.seek.form; tA = S.seek.t0 + (S.clock - S.seek.at);
        B = pose.sc.k < 0.5 ? pose.sc.A : pose.sc.B;
        k = u;
        if (S.seek.from) pose = { sc: pose.sc, cam: H.mixCam(S.seek.from.cam, pose.cam, e), sky: H.mixSky(S.seek.from.sky, pose.sky, e) };
      }
    }
    S.pose = pose;

    // title: the seed breathes with no song yet
    const f = S.mode === 'title' ? { lvl: 0.35, low: 0.2, lmid: 0.2, hmid: 0.2, air: 0.1, on: 0 } : H.calm(t, feat);
    const target = H.seedAt(t, S.mode);
    const sk = 1 - Math.exp(-dt * 2.2);
    S.seed = S.seed.map((v, i) => lerp(v, target[i], sk));

    const beat = 0;
    const exposure = S.mode === 'end' ? 1 : 1;
    G.render({
      A, B, k, tA, tB, t, clock: S.clock, cam: pose.cam, sky: pose.sky, f, beat,
      seed: S.seed, hold: 1, dust: 1, exposure
    });

    H.Lyrics.update(t, S.mode === 'title');
    const frac = t / H.duration;
    seekEl.firstElementChild.style.width = (frac * 100).toFixed(3) + '%';
    seekEl.lastElementChild.style.left = (frac * 100).toFixed(3) + '%';
    seekEl.setAttribute('aria-valuenow', t.toFixed(0));
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { cancelAnimationFrame(raf); raf = 0; }
    else if (!raf) { last = performance.now(); raf = requestAnimationFrame(frame); }
  });
  raf = requestAnimationFrame(frame);

  // #mark: tap M on every moment you feel; C copies the times (to set where the changes land)
  if (/mark/.test(location.hash)) {
    const marks = [];
    const box = document.createElement('div');
    box.style.cssText = 'position:fixed;top:16px;left:16px;font-size:13px;letter-spacing:.06em;color:var(--mist-dim);pointer-events:none;white-space:pre';
    document.body.appendChild(box);
    const show = extra => { box.textContent = H.text('mark.hint') + '\n' + marks.length + ' ' + H.text('mark.count') + (extra ? '\n' + extra : ''); };
    const copy = () => {
      const txt = marks.map(m => m.toFixed(3)).join(', ');
      try { navigator.clipboard.writeText(txt); } catch (e) {}
      try { localStorage.setItem('hana-marks', txt); } catch (e) {}
      show(H.text('mark.copied') + '\n' + txt);
    };
    addEventListener('keydown', e => {
      if (e.code === 'KeyM' && S.mode === 'play') { marks.push(Math.max(0, audio.currentTime - latency)); show(); }
      if (e.code === 'KeyC') copy();
    });
    audio.addEventListener('ended', copy);
    show();
  }

  // developer hooks: #dev
  if (DEV) {
    window.__hana = {
      S, G, H, audio,
      at(t) { S.mode = 'play'; S.manual = t; S.seek = null; S.seed = H.seedAt(t, 'play'); $('#title').classList.add('gone'); return t; },
      title() { S.mode = 'title'; S.manual = null; $('#title').classList.remove('gone'); },
      stop() { cancelAnimationFrame(raf); raf = 0; },
      step(n = 1, dt = 1 / 60) { for (let i = 0; i < n; i++) { S.clock += dt; step(dt); } },
      jump
    };
  }
})();
